import { ErrorMessage } from "./index";

export class FormValidationResult {
    errorMessages: Array<ErrorMessage>;
    get isValid() { return typeof this.errorMessages !== 'undefined' && this.errorMessages.length === 0 };

    constructor() {
        this.errorMessages = new Array<ErrorMessage>();
    }
}